module.exports = __webpack_public_path__ + "static/img/arthroscopy-16.c5425c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-16.jpg
// module id = YO7j
// module chunks = 52